module.exports = __webpack_public_path__ + "static/media/bg-math-icon.26b34ca4.svg";